<template>
  <div class="reviews_rs" :class="{ [curTheme]: true }">

    <div class="rs_header_rh">
      <div class="rh_type-links">
        <button
          class="rh_type-link"
          :class="{ 'rh_type-link--active': activeType === 'review' }"
          @click="activeType = 'review'">
          Отзывы <span class='positive-reviews-count'>&#43;{{ posReviews }}</span>
          <span class='review-delimiter'>&#47;</span>
          <span class='negative-reviews-count'>&#45;{{ negReviews }}</span>
        </button>
        <button
          class="rh_type-link"
          :class="{ 'rh_type-link--active': activeType === 'comment' }"
          @click="activeType = 'comment'">
          Комментарии <span class="rh_type-num">{{ comments.length }}</span></button>
      </div>
      <div class="rh_add-links">
        <div v-if="activeType === 'review' &&
          this.canWriteReview &&
          !isObjectCreator &&
          !objectBlocked">
          <button
            @click="addReviewPopup('review')"
            class="btn-colored-border">Написать отзыв
        </button>
        </div>
        <div v-else-if="activeType === 'comment' &&
          !isObjectCreator &&
          !objectBlocked">
          <button
            @click="addReviewPopup('comment')"
            class="btn-colored-border">Написать комментарий</button>
        </div>
      </div>
    </div>
    <div v-if="activeType === 'review'">
      <app-reviews-list
        :reviews="reviews"
        :objectId="objectId"
        @onUpdateReview = "fetchData()"
        emptyMessage="На данный момент в базе системы нет ни одного отзыва."/>
    </div>

    <div v-else-if="activeType === 'comment'">
      <app-reviews-list
        :reviews="comments"
        :objectCreatorId="objectCreatorId"
        @onUpdateComment = "fetchData()"
        emptyMessage="На данный момент в базе системы нет ни одного комментария."/>
    </div>

    <div v-else-if="activeType === 'antiplagiat'">
      <app-antiplagiat-list
        :reviews="antiplagiat"
        emptyMessage="На данный момент в базе системы нет ни одной проверки
          данного объекта системой Антиплагиат."/>
    </div>

    <el-dialog
      class="rs_popup_rp"
      :visible.sync="add.showPopup">

      <h2 class="rp_header">
        Написать
        <template v-if="add.activeType === 'review'">отзыв</template>
        <template v-else>комментарий</template>
      </h2>

      <template v-if="isAuthenticated">

        <app-inputs ref="inputs">

          <div class="block-wrap rs_block-wrap">
            <app-input
              widget="AppText"
              :options="{ name: 'text', title: 'Текст', required: true, autosize: true }"/>
          </div>
          <template v-if="add.activeType === 'review'">
            <div class="block-wrap rs_block-wrap">
                <app-input
                widget="AppRate"
                :options="{ name: 'grade', title: 'Оцените объект', required: true }"/>
            </div>
          </template>
          <div class="block-wrap rs_block-wrap">
            <app-input
              widget="AppPasswordSimple"
              :options="{ name: 'password', title: 'Введите ваш пароль', required: true }"/>
          </div>
          <div class="block-wrap rs_block-wrap">
            <div class="buttons-wrap">
              <button :disabled="sendingToApi" class="vivid-button"
                @click="submitReview">Отправить</button>
            </div>
          </div>

        </app-inputs>

      </template>

      <template v-else>
        <div class="rp_auth-required">
          <span class="rp_link" @click="$router.push({ path: '/user/register' })">
          Зарегистрируйтесть</span>
          или <span class="rp_link" @click="$router.push({ path: '/user/authenticate' })">
          войдите</span>, чтобы добавить отзыв или комментарий.
        </div>
      </template>

    </el-dialog>

  </div>
</template>

<script>
/* eslint-disable default-case */
import axios from 'axios';
import AppReviewsList from './AppReviewsList';
import AppInputs from '../inputs/AppInputs';
import AppInput from '../inputs/AppInput';
import AppMessages from '../AppMessages';

export default {

  components: {
    AppReviewsList,
    AppInputs,
    AppInput,
    AppMessages,
  },

  props: {
    objectId: '',
    objectCreatorId: '',
    objectBlocked: '',
  },

  data() {
    return {
      sendingToApi: false,
      posReviews: '',
      negReviews: '',
      canWriteReview: false,
      bothTypes: [],
      reviews: [],
      comments: [],
      antiplagiat: [],
      activeType: 'review',
      add: {
        showPopup: false,
        activeType: '',
      },
    };
  },

  created() {
    // Get reviews
    this.fetchData();
  },

  computed: {

    isAuthenticated() {
      return this.$store.getters['user/isAuthenticated'];
    },

    isObjectCreator() {
      const userId = this.$store.getters['user/getUserId'];
      if (userId !== this.objectCreatorId) return false;
      return true;
    },
  },

  methods: {

    fetchData(type) {
      const userId = this.$store.getters['user/getUserId'];
      this.posReviews = 0;
      this.negReviews = 0;
      if (this.objectId) {
        axios.get(`reviews/object/${this.objectId}`, { params: { type } }).then((response) => {
          this.canWriteReview = true;
          this.bothTypes = [];
          this.comments = [];
          this.reviews = [];
          response.data.forEach((review) => {
            this.bothTypes.push(review);
            switch (review.Type) {
              case 'comment':
                this.comments.push(review);
                break;
              case 'review':
                if (review.Grade === 1) this.posReviews += 1;
                else this.negReviews += 1;
                if (this.canWriteReview) {
                  if (review.Author.UserId === userId) this.canWriteReview = false;
                }
                this.reviews.push(review);
                break;
              case 'antiplagiat':
                this.antiplagiat.push(review);
                break;
            }
          });
          if (this.reviews.length === 0 && this.comments.length) {
            this.activeType = 'comment';
          }
        });
      }
    },

    addReviewPopup(type) {
      this.add.activeType = type;
      this.add.showPopup = true;
    },

    submitReview() {
      const inputs = this.$refs.inputs;
      if (!inputs.hasErrors()) {
        const values = inputs.getValues();
        const params = {};
        params.ObjectId = this.objectId;
        params.Text = values.text;
        params.Grade = values.grade;
        params.Type = this.add.activeType;
        /* if (params.Type === 'review' && params.Text.length < 100) {
          this.$message({
            message: 'Минимальная длина отзыва должна составлять 100 символов',
            showClose: true,
            duration: 5000,
          });
          return;
        }
        if (params.Type === 'comment' && params.Text.length < 10) {
          this.$message({
            message: 'Минимальная длина комментария должна составлять 10 символов',
            showClose: true,
            duration: 5000,
          });
          return;
        } */
        this.sendingToApi = true;
        axios.post('users/validatePassword', values.password).then(() => {
          axios.post('reviews', params).then(() => {
            this.$message({
              message: params.Type === 'review' ? 'Отзыв отправлен' : 'Комментарий отправлен',
            });
            this.$refs.inputs.clearValues();
            this.add.showPopup = false;
            this.activeType = this.add.activeType;
            setTimeout(() => {
              this.fetchData();
            }, 2000);
          }).catch((error) => {
            if (error.response && error.response.data) {
              if (error.response.data.length) {
                this.$message({
                  message: error.response.data[0],
                  showClose: true,
                  duration: 5000,
                });
              }
            }
          }).finally(() => {
            this.sendingToApi = false;
          });
        }).catch((error) => {
          this.$message(error.response.data);
          this.sendingToApi = false;
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/main';
.reviews_rs {
  border-radius:10px;
  background: $blocks-bg;
  clear: both;
  .rs_block-wrap {
    background: rgba(0, 0, 0, 0.2);
  }
}
.rs_header_rh {
  box-shadow: none;
  background: $blocks-bg;
  margin-bottom: 20px;
  border-radius: 10px 10px 0px 0px;
  padding: 5px 15px;
  .rh_type-links {
    @include clearfix;
    padding: 15px 15px 0px;
    @media (max-width: 600px) {
      padding: 0 3px 0;
    }
  }
  .rh_type-link {
    float: left;
    display: block;
    background: transparent;
    color: #999;
    padding: 10px 20px 10px 20px;
    margin: 0 50px 0 0;
    border: none;
    font-size: 19px;
    position: relative;
    cursor: pointer;
    @include transition;
    @media (max-width: 600px) {
      padding: 7px 10px 7px 0;
    }
    &:hover {
      color: #fff;
    }
    &.rh_type-link--active {
      background-color: rgba(153, 153, 153, 0.1);
      border-radius: 10px;
      color: #fff;
    }
  }
  .positive-reviews-count {
    color: rgba(149, 195, 2, 0.8);
  }
  .negative-reviews-count {
    color: rgba(215, 66, 120, 0.8);
  }
  .review-delimiter {
    color:#d2d2d2;
  }
  .rh_type-num {
  }
  @media (max-width: 750px) {
    .rh_type-link {
      margin: 0 30px 0 0;
    }
  }
}

.rh_add-links {
  @include clearfix;
  padding: 20px 15px 10px;
  @media (max-width: 600px) {
    padding-left: 0;
    padding-right: 0;
  }
  .rh_add-link {
    float: left;
    display: block;
    padding: 7px 10px 5px 40px;
    margin: 0 30px 20px 0;
    background: transparent;
    border: none;
    color: #fff;
    position: relative;
    cursor: pointer;
    text-align: left;
    @include transition;
    line-height: 15px;
    &:hover {
      color: lighten($color-1, 15%);
    }
    i {
      position: absolute;
      color: lighten($color-1, 15%);
      left: 0;
      top: 0;
      font-size: 18px;
      border-radius: 50%;
      border: 1px solid #666;
      padding: 4px;
    }
  }
}

.rs_popup_rp {
  .rp_header {
    text-align: center;
    margin: 0 0 30px;
    padding: 0;
  }
  .el-dialog__header,
  .el-dialog__body {
    @extend .grad;
  }
  .rp_auth-required {
    padding: 70px 10px;
    text-align: center;
    background: none;
    border-radius: 10px;
    font-size: 16px;
    color: #fff;
  }
  .rp_link {
    color: #fa8faa;
    cursor: pointer;
  }
}

.reviews_rs.theme-w {
  .rs_header_rh {
    .rh_type-link {
      color: #b2b2b2;
      &.rh_type-link--active {
        color: #000;
      }
      &:hover {
        color: #000;
      }
    }
  }
}
.theme-w {
    .reviews_rs {
      background: transparent !important;
      -webkit-box-shadow: 0 1px 12px rgba(0, 0, 0, 0.15);
      box-shadow: 0 1px 12px rgba(0, 0, 0, 0.15);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/review/AppReviews.vue